<template>
  <div>
    <div class="p-inputgroup template-dp">
      <Dropdown
        :id="name"
        :name="name"
        :options="options"
        :option-label="optionLabel"
        :option-value="optionValue"
        :placeholder="placeholder"
        :model-value="inputValue"
        :class="className"
        @input="handleChange"
        @change="checkChange"
      >
        <template #value="slotProps">
          <div v-if="slotProps.value" class="country-item country-item-value">
            <div
              class="color-box"
              :style="{ background: `#` + slotProps.value }"
            />
            <div>{{ Core.getColor(slotProps.value) }}</div>
          </div>
          <span v-else>
            {{ slotProps.placeholder }}
          </span>
        </template>
        <template #option="slotProps">
          <div class="country-item">
            <div
              class="color-box"
              :style="{ background: `#` + slotProps.option.key }"
            />
            <div>{{ slotProps.option.label }}</div>
          </div>
        </template>
      </Dropdown>
      <!-- {{ modelValue }}== {{ optionValue }}=={{ optionLabel }}=={{ inputValue }} -->
    </div>
    <small v-show="errorMessage" class="p-error block mt-1">{{ errorMessage }}</small>
  </div>
</template>
<script>
import { useField } from "vee-validate";
import { watch } from "vue";
import { Core } from "../../../../src/helpers/core";
export default {
  props: {
    options: {
      type: [String, Array],
      default: "",
    },
    optionLabel: {
      type: String,
      default: "",
    },
    optionValue: {
      type: String,
      default: "",
    },
    optionGroupLabel: {
      type: String,
      default: "",
    },
    optionGroupChildren: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    emptyFilterMessage: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    filter: {
      type: Boolean,
      required: "",
    },
    showClear: {
      type: Boolean,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: Boolean,
      default: true,
    },
    addon: {
      type: Boolean,
      default: true,
    },
    btnCreate: {
      type: Boolean,
      default: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const {
      value: inputValue,
      errorMessage,
      handleChange,
      meta,
      resetField,
    } = useField(props.name, undefined, {
      initialValue: String(props.modelValue),
    });
    resetField({
      value: String(props.modelValue),
    });
    watch(
      () => props.modelValue,
      (first) => {
        inputValue.value = first;
      }
    );

    function checkChange(event) {
      emit("change", event);
      inputValue.value = event.value;
      emit("update:modelValue", event.value);
      emit("changeSSR", event);
      emit("changeValue", event);
    }
    function onBtnCreate() {
      emit("btn-create");
    }

    function onBtnEdit() {
      emit("btn-edit");
    }
    return {
      handleChange,
      errorMessage,
      inputValue,
      meta,
      checkChange,
      onBtnEdit,

      onBtnCreate,
    };
  },
  data() {
    return {
      Core: Core,
    };
  },

  methods: {},
};
</script>
<style scoped>
div.p-error .p-select {
  background-color: var(--error-bg-color);
  color: var(--error-color);
}

div.p-error input:focus {
  border-color: var(--error-color);
}

.Dropdown.success input {
  background-color: var(--success-bg-color);
  color: var(--success-color);
}

.Dropdown.success input:focus {
  border-color: var(--success-color);
}

.p-inputgroup {
  display: flex;
  align-items: stretch;
}
.width-72 {
  width: 72% !important;
}
.base-dropdown.p-inputgroup .inputtext,
.fluid .p-inputgroup .inputtext,
.p-inputgroup .inputwrapper,
.fluid .p-inputgroup .input {
  flex: 1 1 auto;
  width: 100% !important;
}

.template-dp :deep(.p-select-label) {
  display: flex;
  align-items: center;
}

.template-dp .country-item-value {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  line-height: normal;
}

.template-dp .country-item-value .color-box,
.template-dp .country-item .color-box {
  float: none;
  margin: 0;
  bottom: 0;
  position: static;
  flex-shrink: 0;
}
</style>
